export type ResolveSpaceResponse = {
  spaceId?: string
  spaceid?: string
}

export const getResolvedSpaceId = (
  response?: ResolveSpaceResponse | null,
): string | null => {
  return response?.spaceId || response?.spaceid || null
}
